module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chooose_group"
  }, [_c('div', {
    staticClass: "layerWrap"
  }, [_c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "group_3"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.researchGroupDetailList), function(researchGroup, index) {
    return _c('div', {
      key: index,
      staticClass: "block_researchgroup"
    }, [_c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      staticClass: "radio-input-attr",
      attrs: {
        "type": "radio",
        "name": "attr",
        "value": "researchGroup.researchGroupName"
      },
      domProps: {
        "checked": researchGroup.researchGroupNo === _vm.displayChosenResearchGroup.researchGroupNo
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-media group",
      on: {
        "click": function($event) {
          return _vm.updateResearchGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-form-checkbox i-style"
    }), _vm._v(" "), _c('span', {
      staticClass: "info_2"
    }, [_vm._v(_vm._s(researchGroup.researchGroupName))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "block_3"
  }, [_c('div', {
    staticClass: "tagWrap research-background-color",
    on: {
      "click": function($event) {
        return _vm.updateChosenResearchGroup()
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("切换课题组")])])])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoWrap"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("请选择课题组")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d424474","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupComponents/ChooseResearchGroup.vue
// module id = 1655
// module chunks = 8